import TextFieldWithLabel from "../Features/TextFieldWithLabel";
import DropdownWithLabel from "../Features/DropdownWithLabel";
import CheckBoxWithChildLabel from "../Features/CheckBoxWithChildLabel";

const FormScheffler = (props) => {
    return <div>
        <div className={"columns-2"}>
            <TextFieldWithLabel fieldName={"firstName"} fieldLabel={"First Name"} register={props.register} errors={props.errors}></TextFieldWithLabel>
            <TextFieldWithLabel fieldName={"lastName"} fieldLabel={"Last Name"} register={props.register} errors={props.errors}></TextFieldWithLabel>
        </div>
        <TextFieldWithLabel fieldName={"emailAddress"} fieldLabel={"Email Address"} register={props.register} errors={props.errors} pattern={/^\S+@\S+$/}></TextFieldWithLabel>
        <TextFieldWithLabel fieldName={"address1"} fieldLabel={"Address"} register={props.register} errors={props.errors}></TextFieldWithLabel>
        <div className={"columns-3"}>
            <TextFieldWithLabel fieldName={"city"} fieldLabel={"City"} register={props.register} errors={props.errors}></TextFieldWithLabel>
            <TextFieldWithLabel fieldName={"state"} fieldLabel={"State"} register={props.register} errors={props.errors}></TextFieldWithLabel>
            <TextFieldWithLabel fieldName={"zip"} fieldLabel={"ZIP"} register={props.register} errors={props.errors} pattern={/^\d{5}?$/}></TextFieldWithLabel>
        </div>

        <DropdownWithLabel fieldName={"cadillacBrandForMe"} fieldLabel={"Please rate the extent to which you agree with the following: 'Cadillac is a Brand For Me'"} register={props.register} errors={props.errors}>
            <option value={""}>Choose one...</option>
            <option value={"Strongly Agree"}>Strongly Agree</option>
            <option value={"Agree"}>Agree</option>
            <option value={"Neither Agree Disagree"}>Neither Agree nor Disagree</option>
            <option value={"Disagree"}>Disagree</option>
            <option value={"Strongly Disagree"}>Strongly Disagree</option>
        </DropdownWithLabel>

        <div className={"lg:columns-2"}>
            <DropdownWithLabel fieldName={"householdVehicle"} fieldLabel={"What is the primary vehicle in your household? "} register={props.register} errors={props.errors}>
                <option value={""}>Choose one...</option>
                <option value={"Car"}>Car</option>
                <option value={"SUV"}>Crossover & SUV</option>
                <option value={"Truck"}>Pickup Truck</option>
                <option value={"Van"}>Van</option>
                <option value={"Electric Vehicle"}>Electric Vehicle</option>
            </DropdownWithLabel>

            <DropdownWithLabel fieldName={"vehicleMake"} fieldLabel={"Vehicle Make? "} register={props.register} errors={props.errors}>
                <option value={""}>Choose one...</option>
                <optgroup label={"GM Brands"}>
                    <option value={"Chevrolet"}>Chevrolet</option>
                    <option value={"Buick"}>Buick</option>
                    <option value={"GMC"}>GMC</option>
                    <option value={"Cadillac"}>Cadillac</option>
                </optgroup>
                <optgroup label={"Other Brands"}>
                    <option value={"Acura"}>Acura</option>
                    <option value={"Alfa Romeo"}>Alfa Romeo</option>
                    <option value={"Audi"}>Audi</option>
                    <option value={"Bentley"}>Bentley</option>
                    <option value={"BMW"}>BMW</option>
                    <option value={"Chrysler"}>Chrysler</option>
                    <option value={"Daimler"}>Daimler</option>
                    <option value={"Dodge"}>Dodge</option>
                    <option value={"Fiat"}>Fiat</option>
                    <option value={"Ford"}>Ford</option>
                    <option value={"Genesis"}>Genesis</option>
                    <option value={"Honda"}>Honda</option>
                    <option value={"Hyundai"}>Hyundai</option>
                    <option value={"Infiniti"}>Infiniti</option>
                    <option value={"Jaguar"}>Jaguar</option>
                    <option value={"Jeep"}>Jeep</option>
                    <option value={"Kia"}>Kia</option>
                    <option value={"Land Rover"}>Land Rover</option>
                    <option value={"Lexus"}>Lexus</option>
                    <option value={"Lincoln"}>Lincoln</option>
                    <option value={"Lotus"}>Lotus</option>
                    <option value={"Lucid"}>Lucid</option>
                    <option value={"Maserati"}>Maserati</option>
                    <option value={"Mazda"}>Mazda</option>
                    <option value={"Mercedes"}>Mercedes</option>
                    <option value={"Mini Cooper"}>Mini Cooper</option>
                    <option value={"Mitsubishi"}>Mitsubishi</option>
                    <option value={"Nissan"}>Nissan</option>
                    <option value={"Polestar"}>Polestar</option>
                    <option value={"Porsche"}>Porsche</option>
                    <option value={"RAM"}>RAM</option>
                    <option value={"Rivian"}>Rivian</option>
                    <option value={"Rolls-Royce"}>Rolls-Royce</option>
                    <option value={"Subaru"}>Subaru</option>
                    <option value={"Smart"}>Smart</option>
                    <option value={"Tesla"}>Tesla</option>
                    <option value={"Toyota"}>Toyota</option>
                    <option value={"Volkswagen"}>Volkswagen</option>
                    <option value={"Volvo"}>Volvo</option>
                </optgroup>
            </DropdownWithLabel>
        </div>

        <CheckBoxWithChildLabel fieldName={"terms"} register={props.register} errors={props.errors}>
            By checking this box, you are subscribing to PGA Communications and agree to PGA of America's Privacy Policy and Terms of Service.
        </CheckBoxWithChildLabel>
    </div>
}

export default FormScheffler;
